<template>
  <span class="small-loader"></span>
</template>

<script>
export default {
  name: 'SmallLoader'
}
</script>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.small-loader{
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 14px;
  width: 14px;
  margin: -7px 0 0 -7px;
  border: 3px rgba($primary, 0.2) solid;
  border-top: 3px $primary solid;
  border-radius: 50%;
  -webkit-animation: spin2 1s infinite linear;
  animation: spin2 1s infinite linear;
  @include transition();
  @include transform(translateY(-5px))
}

@keyframes spin2 {
  from {
    @include transform(translateY(-5px) rotate(0deg));
  }
  to {
    @include transform(translateY(-5px) rotate(359deg));
  }
}
</style>
